import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-holidays-view',
  templateUrl: './holidays-view.component.html',
  styleUrls: ['./holidays-view.component.css']
})
export class HolidaysViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
